import jsPDF from "jspdf";
import type { EndorsementInput } from "@/types";
import { drawAssessmentPage } from "./draw-assessment-page";
import { drawProfilePage } from "./draw-profile-page";
import { drawResumePages, drawResumePagesMd } from "./draw-resume-pages";

export function generateEndorsementPdf(input: EndorsementInput): jsPDF {
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  drawAssessmentPage(doc, input);

  const hasResumeText = !!(input.resumeText && input.resumeText.trim());
  const hasStructured =
    (input.education && input.education.length > 0) ||
    (input.work && input.work.length > 0) ||
    (input.training && input.training.length > 0) ||
    (input.personal && Object.values(input.personal).some((v) => v)) ||
    !!input.careerObjective;

  if (hasResumeText) {
    const isMarkdown = (input.resumeText || "").trimStart().startsWith("# ");
    if (isMarkdown) {
      drawResumePagesMd(doc, input);
    } else {
      drawResumePages(doc, input);
    }
  } else if (hasStructured) {
    drawProfilePage(doc, input);
  }
  return doc;
}

export function downloadEndorsementPdf(input: EndorsementInput, filename?: string): void {
  const doc = generateEndorsementPdf(input);
  const safeName = (input.candidateName || "candidate").replace(/[^a-z0-9]+/gi, "_");
  doc.save(filename || `Endorsement_${safeName}.pdf`);
}
